<template>
  <div>
    <px-view-header title="Integração" title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs" />
    <v-card class="rounded-card">
      <v-card-text>
        <px-listagem-logs-header
          :on-click-refresh="onClickRefresh"
          :loading="loading"
          @change="onChangeFilter"/>
        <div>
          <px-lista-logs
            :logs="logs"
            :loading="loading"
            :on-change-options="onChangeOptions"
            :options-list="optionsList"
            @update="onClickRefresh"/>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import paginationMixin from '@/mixins/pagination-mixin';
import IntegracaoService from '@/api/integracao-service';
import ListagemLogsHeader from './ListagemLogsHeader.vue';

export default {
  mixins: [paginationMixin],
  data() {
    return {
      logs: {
        content: [],
        total: 0,
      },
      listOptions: {
        page: 1,
        limit: 10,
        offset: 0,
        filter: '',
        sort: 'createdIn',
        sortDesc: true,
      },
      optionsList: {},
      loading: false,
      breadcrumbs: [
        { text: 'Minha empresa' },
        { text: 'Integração' },
      ],
    };
  },
  computed: {
    ...mapGetters('painelIntegracao', ['stringFilter']),
  },
  methods: {
    onClickRefresh() {
      this.getLogs();
    },
    onChangeFilter() {
      this.listOptions.filter = this.stringFilter;
      this.resetPage();
      this.getLogs();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getLogs();
    },
    resetPage() {
      this.listOptions = this.resetPagination(this.listOptions);
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getLogs() {
      this.loading = true;

      const { limit, offset } = this.listOptions;
      IntegracaoService.getLogsIntegracao({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.logs = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.optionsList = this.pageToOptions(this.listOptions);
    this.listOptions.filter = this.stringFilter;
  },
  components: {
    pxListagemLogsHeader: ListagemLogsHeader,
  },
};
</script>
